// extracted by mini-css-extract-plugin
export default {"Loader":"LessonPageContentPage_Loader__ZD--S","Content":"LessonPageContentPage_Content__167+L"};